import { Table } from "reactstrap";
import { moneyFormatter } from "../../../../utils/helper";
const CandidateBillingCredit = ({ netCommission, recruiters }) => {
  return (
    <div>
      <h5 className="mb-2">Candidate Billing Credit</h5>

      <div className="dark-table">
        <Table className="transparentTable">
          <thead>
            <tr>
              <th style={{ width: "40%" }}>Name</th>
              <th style={{ width: "30%" }}>Credit%</th>
              <th style={{ width: "30%", textAlign: "right" }} align="right">
                Billing Credit
              </th>
            </tr>
          </thead>

          <tbody>
            {recruiters?.length > 0 &&
              recruiters?.map((item: any) => {
                return (
                  <tr>
                    <td>{item?.user?.fullName}</td>

                    <td>{item?.splitPercentage}%</td>

                    <td align="right">
                      {moneyFormatter(
                        (netCommission * 0.5 * item?.splitPercentage) / 100 || 0
                      )}
                    </td>
                  </tr>
                );
              })}
          </tbody>

          <tfoot>
            <tr>
              <td>
                <span className="valueText">Total Credit:</span> 50%
              </td>
              <td></td>
              <td align="right">
                <span className="valueText">Total Fee: </span>

                {moneyFormatter(netCommission * 0.5 || 0)}
              </td>
            </tr>
          </tfoot>
        </Table>
      </div>
    </div>
  );
};

export default CandidateBillingCredit;
